import IconCheck from '@/asset/icons/check';
import { ClassEnum } from '@/constants/enum';

interface IProps {
  isChecked?: boolean;
}

const RadioInput = ({ isChecked }: IProps = {}) => {
  return <div className={ClassEnum.RadioInput}>{isChecked && <IconCheck />}</div>;
};

export default RadioInput;
